export default function PlusIcon() {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 2H7.5V7H2.5V9H7.5V14H9.5V9H14.5V7H9.5V2Z"
        fill="currentColor"
      />
    </svg>
  );
}
